/*
  * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
  * SPDX-License-Identifier: MIT
  *
  * Licensed under the MIT License. See the LICENSE accompanying this file
  * for the specific language governing permissions and limitations under
  * the License.
  */

import React from 'react';

import { I18n } from '@aws-amplify/core';

// reason クエリパラメータに応じて表示する i18n キーを切り替える
const REASON_TO_I18N_KEY = {
	missing_client_id: 'ERROR_PAGE_MISSING_CLIENT_ID',
	unknown_client:    'ERROR_PAGE_UNKNOWN_CLIENT',
};

class ErrorPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {}
	}

	render() {
		const qs = new URLSearchParams(window.location.search);
		const reason = qs.get('reason');
		const i18nKey = REASON_TO_I18N_KEY[reason] || 'ERROR_PAGE_MESSAGE';

		return (
			<h1>
				{I18n.get(i18nKey)}
			</h1>
		)
	}
}

export default ErrorPage;
